<template>
	<div>
		<nav class="calendario">
			<ul class="row header">
				<ul class="row-line col-xs-2">
					empresa
				</ul>
				<ul class="row-line col-xs-10">
					<ul
						v-for="(mes, index) in 12"
						:key="index"
						class="dTable col-xs-1"
					>
						{{
							meses[mes]
						}}
					</ul>
				</ul>
			</ul>
		</nav>

		<nav class="calendario">
			<ul
				class="row body"
				v-for="(cont, index) in contByYear"
				:key="index"
			>
				<ul
					class="row-line col-xs-2 title"
					:title="
						'Razão social: ' +
						cont.cnpj.razao_social +
						'; CNPJ: ' +
						cont.cnpj.cnpj
					"
				>
					{{
						cont.cnpj.razao_social
					}}
				</ul>
				<ul class="row-line col-xs-10">
					<li
						v-for="(mes, index) in 12"
						:key="index"
						class="dTable col-xs-1"
					>
						{{ getValue(cont, mes) }}
					</li>
				</ul>
			</ul>
		</nav>

		<nav class="calendario">
			<ul class="row header">
				<ul class="row-line col-xs-2">
					Faturamento
				</ul>
				<ul class="row-line col-xs-10">
					<ul
						v-for="(mes, index) in 12"
						:key="index"
						class="dTable col-xs-1"
					>
						{{
							getTotalMonth(mes)
						}}
					</ul>
				</ul>
			</ul>
			<ul class="row header" v-if="dataIn.com != 0">
				<ul class="row-line col-xs-2">
					Comissão
				</ul>
				<ul class="row-line col-xs-10">
					<ul
						v-for="(mes, index) in 12"
						:key="index"
						class="dTable col-xs-1"
					>
						{{
							parseFloat(
								getTotalMonth(mes) *
									(parseInt(dataIn.com) / 100)
							).toFixed(2)
						}}
					</ul>
				</ul>
			</ul>
		</nav>
	</div>
</template>

<script>
	export default {
		name: 'ControleDeComissao',
		props: ['dataIn', 'ano', 'parcelasAgrupadas', 'situacao'],
		data() {
			return {
				meses: [
					'',
					'Jan',
					'Fev',
					'Mar',
					'Abr',
					'Mai',
					'Jun',
					'Jul',
					'Ago',
					'Set',
					'Out',
					'Nov',
					'Dez',
				],
				tCom: [],
				t: 0,
			};
		},
		computed: {
			contByYear() {
				return this.dataIn.con.filter((item) => {
					const anoContrato = new Date(item.data).getFullYear();
					const isAnoCorreto = anoContrato === this.ano;

					const isSituacaoCorreta =
						this.situacao === 'todos' ||
						(this.situacao === 'novo' &&
							item.data !== item.renovacao + ' 00:00:00') ||
						(this.situacao === 'renovado' &&
							item.data === item.renovacao + ' 00:00:00');

					return isAnoCorreto && isSituacaoCorreta;
				});
			},
		},
		methods: {
			getTotalMonth(mes) {
				let sun = 0;
				this.contByYear.forEach((item) => {
					let val = this.getValue(item, mes);
					sun += val != '-' ? parseFloat(val) : 0;
				});
				return parseFloat(sun).toFixed(2);
			},
			getValue(cont, mes) {
				// console.log( cont, mes )
				let date = new Date(cont.data);
				if (this.ano != date.getFullYear()) return '-';
				else {
					let mesTest = date.getMonth() + 1;
					let parc =
						this.parcelasAgrupadas || parseInt(cont.parcelas);

					if (mes >= mesTest && mes < mesTest + parc) {
						return parseFloat(
							parseFloat(cont.valor) / parc
						).toFixed(2);
					} else return '-';
				}
			},
		},
	};
</script>

<style scoped>
	.clear {
		clear: both;
	}
	.row-line {
		padding: 5px 0;
	}
	.title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		padding: 5px;
	}
	.header ul {
		font-weight: bold;
	}
	.body ul {
		border-bottom: 1px solid #cecece;
	}

	.calendario::-webkit-scrollbar {
		width: 0px;
	}
	/* .calendario::-webkit-scrollbar-thumb {
	}
	.calendario::-webkit-scrollbar-track {
	} */
	.calendario {
		overflow-y: auto;
		max-height: 450px;
	}
	.calendario .row,
	.dTable {
		padding: 0;
		list-style: none;
		margin: 0;
	}
	.calendario .row:nth-child(2n) {
		background-color: rgba(206, 206, 206, 0.19);
	}
	.dTable {
		text-align: center;
		border-left: 1px solid #cecece;
		font-size: 12px;
		height: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/sellers/ctrl.comissao.vue